module.exports = __webpack_public_path__ + "2efaa7cefecac519996c3c25cb73c42d.jpg";